"use client";

const EnvNames = {
  prod: "Production",
  stag: "Staging",
  dev: "Development",
} as const;

export function EnvBar({ env }: { env: "prod" | "stag" | "dev" }) {
  if (env === "prod") {
    return <></>;
  }
  let envName = EnvNames[env];

  return (
    <div className="top-0 right-0 z-50 absolute w-64 bg-orange-500 flex items-center justify-center p-1">
      {envName.toUpperCase()}
    </div>
  );
}
